class RgUtils {
	static formatRg(rg) {
		const digits = rg.replace(/[^0-9]/g, '');
		if (digits.length <= 2) {
			return digits;
		} else if (digits.length <= 5) {
			return digits.substring(0, 2) + '.' + digits.substring(2);
		} else if (digits.length <= 8) {
			return digits.substring(0, 2) + '.' + digits.substring(2, 5) + '.' + digits.substring(5);
		} else {
			return digits.substring(0, 2) + '.' + digits.substring(2, 5) + '.' + digits.substring(5, 8) + '-' + digits.substring(8);
		}
	}

	static cleanRg(rg) {
		return rg.replace(/[^0-9]/g, '');
	}
}

export default RgUtils;
